export const notifyRules = {
  NOTIFICATION: {
    duration: 3500,
    position: "bottom-right",
    style: {
      borderRadius: "10px",
      background: "#333",
      color: "#fff",
    },
    icon: "🚨",
  },
  ERROR: {
    duration: 4000,
    position: "bottom-right",
    style: {
      borderRadius: "10px",
      background: "#f52b02",
      color: "black",
    },
    icon: "❌",
  },
  SUCCESS: {
    duration: 3500,
    position: "bottom-right",
    style: {
      borderRadius: "10px",
      background: "#71f22c",
      color: "black",
    },
    icon: "✅",
  },
};
